import type { ImageOutputMimeType } from '@buffer-mono/popcorn'

export const getImageEditorOutputMimeType = (
  blob: Blob,
  sourceUrl: string,
  supportsWebpOutput: boolean,
): ImageOutputMimeType => {
  if (blob.type === 'image/jpeg' || blob.type === 'image/png') {
    return blob.type
  }
  if (blob.type === 'image/webp') {
    return supportsWebpOutput ? 'image/webp' : 'image/jpeg'
  }

  const path = sourceUrl.split(/[?#]/, 1)[0]?.toLowerCase() ?? ''
  if (path.endsWith('.png')) return 'image/png'
  if (path.endsWith('.webp')) {
    return supportsWebpOutput ? 'image/webp' : 'image/jpeg'
  }

  return 'image/jpeg'
}
